module.exports = __webpack_public_path__ + "static/media/644JettStNW_2018-06-26_133.33fb5b5c.jpg";